import * as React from 'react';
import styled from 'styled-components';
import { GalleryContext } from './Index';

import { useProgressiveImage } from '../../../../utils/hooks/useProgressiveImage';
import { GetPropertyTop } from '../../../../../__types__/generated/GetPropertyTop';

export const GalleryOverview: React.FC<{
  data: GetPropertyTop;
}> = React.memo(({ data }) => {
  const { select, setGalleryOverviewOpen } = React.useContext(GalleryContext);
  return (
    <StyledGalleryOverview>
      <StyledGalleryOverviewContainer>
        {data.getProperty?.images?.list?.map((item, index) => (
          <GalleryOverlayImage
            key={`gallery_overview_${index}`}
            onClick={() => {
              select(index);
              setGalleryOverviewOpen(false);
            }}
            url={item?.url || ''}
          />
        ))}
      </StyledGalleryOverviewContainer>
    </StyledGalleryOverview>
  );
});

const StyledGalleryOverview = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  z-index: 100;
  overflow-y: scroll;
`;

const StyledGalleryOverviewContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 30px;
`;

const GalleryOverlayImage: React.FC<{
  url?: string;
  onClick: () => void;
}> = ({ url, onClick }) => {
  const { loaded } = useProgressiveImage({
    url: url,
  });
  return (
    <StyledGalleryImage
      className={loaded ? 'image-loaded' : ''}
      onClick={onClick}
    >
      <img src={url} />
    </StyledGalleryImage>
  );
};

const StyledGalleryImage = styled.div`
  width: calc((100% / 5) - 10px);
  height: 200px;
  margin-right: 10px;
  margin-bottom: 10px;
  background: rgb(40, 40, 40);

  @media all and (max-width: 499px) {
    width: 100%;
    max-width: 200px;
    margin-right: 0;
  }

  @media all and (min-width: 500px) and (max-width: 699px) {
    width: 100%;
    max-width: 200px;
  }

  @media all and (min-width: 700px) and (max-width: 799px) {
    width: calc((100% / 3) - 10px);
    max-width: 200px;
  }
  @media all and (min-width: 800px) and (max-width: 999px) {
    width: calc((100% / 4) - 10px);
    max-width: 200px;
  }

  &:hover {
    cursor: pointer;
  }

  img {
    transition: opacity 0.15s ease-in-out;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
  }

  &.image-loaded {
    img {
      opacity: 1;
    }
  }
`;
